module.exports = __webpack_public_path__ + "img/12.38ea2d44.png";